// extracted by mini-css-extract-plugin
export var currencyInput = "_ob-1";
export var currencySymbol = "_ob-0";